export default function(value)
 {
    const d = new Date()
    d.setDate(d.getDate() + value)
    return d 
  }